import { apiSlice } from "../services/apiSlice";

export const formsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // CustomForm Builder
        createWidget: builder.mutation({
            query: (data) => ({
                url: `/widgets`,
                method: "POST",
                body: {
                    ...data,
                },
            }),
            invalidatesTags: ['widgets'],
        }),

        updateWidget: builder.mutation({
            query: ({ id, data }) => ({
                url: `/widgets/${id}`,
                method: "PUT",
                body: {
                    ...data,
                },
            }),
            invalidatesTags: ['widgets'],
        }),

        getAllWidgets: builder.query({
            query: (params) => ({
                url: `/widgets`,
                params: params,
            }),
            providesTags: ['widgets'],
        }),

        getSingleWidgets: builder.query({
            query: (id) => ({
                url: `/widgets/${id}`,
            }),
            providesTags: ['widgets'],
        }),

        widgetStatus: builder.mutation({
            query: ({ id, data }) => ({
                url: `/widgets/${id}/status`,
                method: "PATCH",
                body: {
                    ...data,
                },
            }),
        }),

        deleteWidget: builder.mutation({
            query: (id: number) => ({
                url: `/widgets/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['widgets']
        }),

        reorderLayout: builder.mutation({
            query: ({ data, scope }) => ({
                url: `/detail-page/${scope}/layout/reorder`,
                method: "PUT",
                body: { ...data }
            }),
        }),

        duplicateWidget: builder.mutation({
            query: ({ id }) => ({
                url: `widgets/duplicate-widget/${id}`,
                method: "PUT",
            }),
        }),
        getOrgDetails: builder.query({
            query: (data) => ({
                url: `/fields/records/fields`,
                method: "PUT",
                body: {
                    ...data,
                },
            }),
            // invalidatesTags: ['widgets'],
        }),


        editOrganization: builder.mutation({
            query: (data) => ({
                url: `/fields/records/fields`,
                method: "PUT",
                body: { ...data }
            }),
        }),

    }),
});

export const {
    useCreateWidgetMutation,
    useGetAllWidgetsQuery,
    useGetSingleWidgetsQuery,
    useUpdateWidgetMutation,
    useWidgetStatusMutation,
    useDeleteWidgetMutation,
    useReorderLayoutMutation,
    useDuplicateWidgetMutation,
    useEditOrganizationMutation,
    useGetOrgDetailsQuery

} = formsApiSlice;
